export const UPDATE_UNIVERSITIES = "UPDATE_UNIVERSITIES";

export const updateUniversities = (value) => ({
  type: UPDATE_UNIVERSITIES,
  value,
});
